<template>
  <cv-text-input
    class="ff-input"
    v-bind="$attrs"
    v-on="inputListeners"
    v-if="!search"
  />
  <cv-search
    v-else
    class="ff-input"
    v-bind="$attrs"
    v-on="inputListeners"
  />
</template>

<script>
export default {
  name: 'ff-input',
  props: [
    'action',
    'search'
  ],
  data () {
    return {
    }
  },
  computed: {
    inputListeners () {
      return {
        ...this.$listeners,
        input: (e) => {
          this.$emit('input', e)
          if (!this.action) return
          return this.action()
        }
      }
    }
  }
}
</script>

<style scoped lang="scss">
  @import "../../assets/styles/app.scss";

  .ff-input {
    font-size: $fontSize-normal;
    margin-bottom: $unit-1;
    justify-content: space-evenly;
  }

  ::v-deep .bx--text-input,
  ::v-deep .bx--search-input {
    @include input-container;
  }

  ::v-deep .bx--label {
    margin: 0.5em 0;
  }

  .is-dark {
    ::v-deep .bx--label {
      color: $color-white;
    }
  }

</style>
